/**
 * Created by sandro on 7/16/17.
 */
import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {withStyles, createStyleSheet} from 'material-ui/styles'


const styleSheet = createStyleSheet('Article', theme => ({
    text: {
        textAlign: 'justify',
        margin: theme.spacing.unit * 2,
    },
    title: {
        marginLeft: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit * 2,
    }
}));


class Article extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    renderChildren = () => {
        const children = this.props.children;
        if (children === undefined) {
            return null
        } else {
            return (
                children.map((child) => {
                    return child
                })
            )
        }
    }

    render() {
        const classes = this.props.classes;

        return (
            <div>
                <h2 className={classes.title}>{this.props.title}</h2>

                <p className={classes.text}>{this.props.text}</p>

                <p className={classes.text}>{this.renderChildren()}</p>
            </div>
        )
    }
}

Article.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(Article);




// WEBPACK FOOTER //
// ./src/article.jsx